import {formatToCurrencyType} from "helper/common";
import moment from "moment";
import React from "react";
import {FORMAT_TIME} from "types/enums";

const getTodayString = () => {
  // const today = moment().format();
  const day = moment().format("DD");
  const month = moment().format("MM");
  const year = moment().format("YYYY");
  const time = moment().format("HH:mm");
  return `${time} Ngày ${day} tháng ${month} năm ${year}`;
};

const column: any = [
  {
    title: "STT",
    dataIndex: "stt",
    key: "stt",
    render: (text, record, index) => index + 1,
    width: "4%",
    fixed: "left",
    align: "center",
  },
  {
    title: "Nội dung",
    dataIndex: "tenChiDinh",
    key: "tenChiDinh",
    align: "left",
    width: "40%",
  },
  {
    title: "SL",
    align: "center",
    dataIndex: "soLuong",
    key: "soLuong",
  },
  {
    title: "Đơn giá BV",
    dataIndex: "donGiaBV",
    key: "donGiaBV",
    align: "right",
    width: "12%",
    render: (value, record, index) => {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "Số tiền miễn giảm",
    dataIndex: "soTienMienGiam",
    key: "soTienMienGiam",
    align: "right",
    width: "12%",
    render: (value, record, index) => {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "Lý do miễn giảm",
    dataIndex: "lyDoMienGiam",
    key: "lyDoMienGiam",
    align: "left",
    width: "12%",
  },
  {
    title: "Thành tiền",
    dataIndex: "thanhTien",
    key: "thanhTien",
    align: "right",
    width: "12%",
    render: (value, record, index) => {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
];

export {column, getTodayString};
